export default {"src":"/_next/static/media/expand-arrow.49ee6207.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};